import { render, staticRenderFns } from "./sideAdvertisingSpace.vue?vue&type=template&id=a261bb46&scoped=true"
import script from "./sideAdvertisingSpace.vue?vue&type=script&lang=js"
export * from "./sideAdvertisingSpace.vue?vue&type=script&lang=js"
import style0 from "./sideAdvertisingSpace.vue?vue&type=style&index=0&id=a261bb46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a261bb46",
  null
  
)

export default component.exports